export type ModuleKey =
  | 'PROCUREMENT' | 'ISSUES' | 'DOC_CONTROL' | 'MEETINGS'
  | 'PROJECT' | 'AI_EVALUATION' | 'SUBMITTALS' | 'SCHEDULE' | 'COST_CONTROL' | 'PHOTOS'

export type ModuleMeta = { key: ModuleKey; labelKey: string; hasDrilldown: boolean }

// No ORGANIZATION or PAYMENTS column: org-scoped modules have no project axis
// (Freelo #31448979) — the backend rejects their per-project overrides outright.
// PROJECT (= project admin) deliberately leads the module columns.
export const MODULE_META: readonly ModuleMeta[] = [
  { key: 'PROJECT', labelKey: 'Project_module_name', hasDrilldown: false },
  { key: 'PROCUREMENT', labelKey: 'Procurement_module_name', hasDrilldown: false },
  { key: 'ISSUES', labelKey: 'Issues_module_name', hasDrilldown: true },
  { key: 'DOC_CONTROL', labelKey: 'DocControl_module_name', hasDrilldown: true },
  { key: 'MEETINGS', labelKey: 'Meetings_module_name', hasDrilldown: true },
  { key: 'AI_EVALUATION', labelKey: 'AiEvaluation_module_name', hasDrilldown: false },
  { key: 'SUBMITTALS', labelKey: 'Submittals_module_name', hasDrilldown: false },
  { key: 'SCHEDULE', labelKey: 'Schedule_module_name', hasDrilldown: false },
  { key: 'PHOTOS', labelKey: 'Photos_module_name', hasDrilldown: false },
  { key: 'COST_CONTROL', labelKey: 'CostControl_module_name', hasDrilldown: false },
] as const

export const ALL_MODULE_KEYS: readonly ModuleKey[] = MODULE_META.map((m) => m.key)
